exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".alert{align-items:center;animation:.5s ease-in-out 0s 1 light-bounce-in;bottom:1rem;display:flex;left:0;margin:auto;margin-top:-30px;max-width:30rem;position:relative;right:0;z-index:10000;background-color:none;border:none}.alert .alert-body{margin-bottom:-5px;z-index:1000;position:relative}.close:active,.close:focus{outline:none}@keyframes light-bounce-in{0%{opacity:0;transform:translateY(20%)}50%{transform:translateY(-5%)}100%{opacity:1;transform:translateY(0%)}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/AutoDismissAlert/AutoDismissAlert.scss
// module id = 251
// module chunks = 0